import {v4 as uuid} from 'uuid';

import {
  between, bit, FilterDefinition, fps, has, hasNo, is, isNull, isZero, larger, min, pixels, smaller,
} from '../../shared/models/filter';

export const movieFilters: FilterDefinition[] = [
  {
    field: 'Name',
    label: 'Title {0} {1}',
    title: 'FILTERS.TITLES.TITLE',
    operations: [
      {
        operation: 'contains',
        label: 'FILTERS.OPERATIONS.CONTAINS',
        type: 'text',
        open: false,
        id: uuid(),
      },
      {
        operation: '!contains',
        label: 'FILTERS.OPERATIONS.NOTCONTAINS',
        type: 'text',
        open: false,
        id: uuid(),
      },
      {
        operation: '==',
        label: 'FILTERS.OPERATIONS.EQUAL',
        type: 'text',
        open: false,
        id: uuid(),
      },
      {
        operation: 'startsWith',
        label: 'FILTERS.OPERATIONS.STARTSWITH',
        type: 'text',
        open: false,
        id: uuid(),
      },
      {
        operation: 'endsWith',
        label: 'FILTERS.OPERATIONS.ENDSWITH',
        type: 'text',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'IMDB',
    label: 'Imdb {0} {1}',
    title: 'FILTERS.TITLES.IMDB',
    operations: [
      {
        operation: '==',
        label: is,
        type: 'text',
        open: false,
        id: uuid(),
      },
      {
        operation: 'null',
        label: isNull,
        type: 'none',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'TMDB',
    label: 'Tmdb {0} {1}',
    title: 'FILTERS.TITLES.TMDB',
    operations: [
      {
        operation: '==',
        label: is,
        type: 'text',
        open: false,
        id: uuid(),
      },
      {
        operation: 'null',
        label: isNull,
        type: 'none',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'Images',
    label: 'Images {0} {1}',
    title: 'FILTERS.TITLES.IMAGES',
    operations: [
      {
        operation: '!null',
        label: has,
        type: 'dropdown',
        itemType: 'static',
        items: [
          {label: 'Primary', value: 'Primary'},
          {label: 'Logo', value: 'Logo'},
        ],
        open: false,
        id: uuid(),
      },
      {
        operation: 'null',
        label: hasNo,
        type: 'dropdown',
        itemType: 'static',
        items: [
          {label: 'Primary', value: 'Primary'},
          {label: 'Logo', value: 'Logo'},
        ],
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'Genres',
    label: 'Genres {0} {1}',
    title: 'COMMON.GENRES',
    operations: [
      {
        operation: 'any',
        label: has,
        type: 'dropdown',
        itemType: 'url',
        itemUrl: '1/genre',
        open: false,
        id: uuid(),
      },
      {
        operation: '!any',
        label: hasNo,
        type: 'dropdown',
        itemType: 'url',
        itemUrl: '1/genre',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'Subtitles',
    label: 'Subtitles {0} {1}',
    title: 'COMMON.SUBTITLES',
    operations: [
      {
        operation: 'empty',
        label: 'FILTERS.OPERATIONS.HASNONE',
        type: 'none',
        open: false,
        id: uuid(),
      },
      {
        operation: 'any',
        label: has,
        type: 'dropdown',
        itemType: 'url',
        itemUrl: '1/subtitle',
        open: false,
        id: uuid(),
      },
      {
        operation: '!any',
        label: hasNo,
        type: 'dropdown',
        itemType: 'url',
        itemUrl: '1/subtitle',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'CommunityRating',
    label: 'Community rating {0} {1}',
    title: 'COMMON.COMMUNITYRATING',
    operations: [
      {
        operation: '==',
        label: is,
        type: 'number',
        unit: '',
        open: false,
        id: uuid(),
      },
      {
        operation: 'between',
        label: between,
        type: 'range',
        unit: '',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'RunTimeTicks',
    label: 'Runtime {0} {1}',
    title: 'COMMON.RUNTIME',
    operations: [
      {
        operation: '<',
        label: 'FILTERS.OPERATIONS.SHORTER',
        type: 'number',
        unit: min,
        open: false,
        id: uuid(),
      },
      {
        operation: '>',
        label: 'FILTERS.OPERATIONS.LONGER',
        type: 'number',
        unit: min,
        open: false,
        id: uuid(),
      },
      {
        operation: 'between',
        label: between,
        type: 'range',
        unit: min,
        open: false,
        id: uuid(),
      },
      {
        operation: 'null',
        label: isZero,
        type: 'none',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'SizeInMb',
    label: 'Size {0} {1}',
    title: 'COMMON.SIZE',
    operations: [
      {
        operation: '>',
        label: larger,
        type: 'number',
        unit: 'COMMON.GB',
        open: false,
        id: uuid(),
      },
      {
        operation: '<',
        label: smaller,
        type: 'number',
        unit: 'COMMON.GB',
        open: false,
        id: uuid(),
      },
      {
        operation: 'between',
        label: between,
        type: 'range',
        unit: 'COMMON.GB',
        open: false,
        id: uuid(),
      },
      {
        operation: 'null',
        label: isZero,
        type: 'none',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'Codec',
    label: 'Codec {0} {1}',
    title: 'COMMON.CODEC',
    operations: [
      {
        operation: 'any',
        label: has,
        type: 'dropdown',
        itemType: 'url',
        itemUrl: '1/codec',
        open: false,
        id: uuid(),
      },
      {
        operation: '!any',
        label: hasNo,
        type: 'dropdown',
        itemType: 'url',
        itemUrl: '1/codec',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'VideoRange',
    label: 'Video range {0} {1}',
    title: 'COMMON.VIDEORANGE',
    operations: [
      {
        operation: 'any',
        label: has,
        type: 'dropdown',
        itemType: 'url',
        itemUrl: '1/videorange',
        open: false,
        id: uuid(),
      },
      {
        operation: '!any',
        label: hasNo,
        type: 'dropdown',
        itemType: 'url',
        itemUrl: '1/videorange',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'BitDepth',
    label: 'Bit depth {0} {1}',
    title: 'COMMON.BITDEPTH',
    operations: [
      {
        operation: '>',
        label: larger,
        type: 'number',
        unit: bit,
        open: false,
        id: uuid(),
      },
      {
        operation: '<',
        label: smaller,
        type: 'number',
        unit: bit,
        open: false,
        id: uuid(),
      },
      {
        operation: 'between',
        label: between,
        type: 'range',
        unit: bit,
        open: false,
        id: uuid(),
      },
      {
        operation: 'null',
        label: isZero,
        type: 'none',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'Height',
    label: 'Height {0} {1}',
    title: 'COMMON.HEIGHT',
    operations: [
      {
        operation: '==',
        label: is,
        type: 'number',
        unit: pixels,
        open: false,
        id: uuid(),
      },
      {
        operation: '>',
        label: larger,
        type: 'number',
        unit: pixels,
        open: false,
        id: uuid(),
      },
      {
        operation: '<',
        label: smaller,
        type: 'number',
        unit: pixels,
        open: false,
        id: uuid(),
      },
      {
        operation: 'between',
        label: between,
        type: 'range',
        unit: pixels,
        open: false,
        id: uuid(),
      },
      {
        operation: 'null',
        label: isZero,
        type: 'none',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'Width',
    label: 'Width {0} {1}',
    title: 'COMMON.WIDTH',
    operations: [
      {
        operation: '==',
        label: is,
        type: 'number',
        unit: pixels,
        open: false,
        id: uuid(),
      },
      {
        operation: '<',
        label: larger,
        type: 'number',
        unit: pixels,
        open: false,
        id: uuid(),
      },
      {
        operation: '>',
        label: smaller,
        type: 'number',
        unit: pixels,
        open: false,
        id: uuid(),
      },
      {
        operation: 'between',
        label: between,
        type: 'range',
        unit: pixels,
        open: false,
        id: uuid(),
      },
      {
        operation: 'null',
        label: isZero,
        type: 'none',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'AverageFrameRate',
    label: 'FrameRate {0} {1}',
    title: 'FILTERS.TITLES.FRAMERATE',
    operations: [
      {
        operation: '==',
        label: is,
        type: 'number',
        unit: fps,
        open: false,
        id: uuid(),
      },
      {
        operation: '>',
        label: larger,
        type: 'number',
        unit: fps,
        open: false,
        id: uuid(),
      },
      {
        operation: '<',
        label: smaller,
        type: 'number',
        unit: fps,
        open: false,
        id: uuid(),
      },
      {
        operation: 'between',
        label: between,
        type: 'range',
        unit: fps,
        open: false,
        id: uuid(),
      },
      {
        operation: 'null',
        label: isZero,
        type: 'none',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
  {
    field: 'Container',
    label: 'Container {0} {1}',
    title: 'FILTERS.TITLES.CONTAINER',
    operations: [
      {
        operation: '==',
        label: is,
        type: 'dropdown',
        itemType: 'url',
        itemUrl: '1/container',
        open: false,
        id: uuid(),
      },
      {
        operation: '!=',
        label: 'FILTERS.OPERATIONS.ISNOT',
        type: 'dropdown',
        itemType: 'url',
        itemUrl: '1/container',
        open: false,
        id: uuid(),
      },
      {
        operation: 'null',
        label: isNull,
        type: 'none',
        open: false,
        id: uuid(),
      },
    ],
    open: false,
    id: uuid(),
  },
];
